import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getRooms(params) {
    return api.get(ENDPOINTS.ROOMS.BASE, { params });
}
export function getRoom(id) {
    return api.get(ENDPOINTS.ROOMS.BY_ID(id));
}
export function createRoom(payload) {
    return api.post(ENDPOINTS.ROOMS.BASE, payload);
}
export function updateRoom(id, payload) {
    return api.patch(ENDPOINTS.ROOMS.BY_ID(id), payload);
}
export function deleteRoom(id) {
    return api.delete(ENDPOINTS.ROOMS.BY_ID(id));
}
